import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { deleteData, getData, getDataById, postData, postDataWithParams, updateData } from "../../../service/Service";

const initialState = {
  data: {
    docs: [],
  },
  updatedTime: 0,
  isLoading: true,
  isError: "",
  message: "",
  postMessage: "",
  postStatus: "",
  deleteMessage: "",
  deleteStatus: "",
  updateMessage: "",
  updateStatus: "",
};

export const getStockVegetables = createAsyncThunk(
  "admin/stock-vegetables",
  async (data, { rejectWithValue }) => {
    try {
      const result = await getData("/admin/stock-vegetables", data.token, data.params);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const getStockVegetablesById = createAsyncThunk(
  "admin/stock-vegetables/id",
  async (data, { rejectWithValue }) => {
    try {
      const result = await getDataById("/admin/stock-vegetables/", data.token, data.id);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const sortStockVegetables = createAsyncThunk(
  "admin/stock-vegetables/sort",
  async (data, { rejectWithValue }) => {
    try {
      const result = await postDataWithParams(
        "/admin/stock-vegetables/search",
        data.token,
        data.body,
        data.params
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const postStockVegetables = createAsyncThunk(
  "admin/stock-vegetables/post",
  async (data, { rejectWithValue }) => {
    try {
      const result = await postData("/admin/stock-vegetables", data.token, data.data);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const deleteStockVegetables = createAsyncThunk(
  "admin/stock-vegetables/delete",
  async (data, { rejectWithValue }) => {
    try {
      const result = await deleteData("/admin/stock-vegetables/", data.token, data.data);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const updateStockVegetables = createAsyncThunk(
  "admin/stock-vegetables/edit",
  async (data, { rejectWithValue }) => {
    try {
      const result = await updateData(
        "/admin/stock-vegetables/",
        data.token,
        data.id,
        data.value
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);


const stockVegetablesSlice = createSlice({
  name: "Stock Vegetables Store",
  initialState: initialState,
  reducers: {
    addStockVegetables(state, action) {
      state.data.docs.unshift(action.payload);
    },
    sortStockVegetables(state, action) {
      state.data.docs = action.payload;
    },
    deleteStockVegetables(state, action) {
      state.data.docs = state.data.docs.filter(
        (item) => item._id !== action.payload
      );
    },
    editStockVegetables(state, action) {
      let x = state.data.docs.findIndex((item) => item._id === action.payload._id);
      state.data.docs[x] = action.payload;
    },
  },
  extraReducers: {
    [getStockVegetables.pending]: (state, ) => {
      state.isLoading = true;
    },
    [getStockVegetables.fulfilled]: (state, action) => {
      state.data = action.payload.data;
      state.isError = false;
      state.isLoading = false;
      state.updatedTime = Date.now();
      state.message = action.payload.message;
    },
    [getStockVegetables.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [getStockVegetablesById.pending]: (state, ) => {
      state.isLoading = true;
    },
    [getStockVegetablesById.fulfilled]: (state, action) => {
      state.isError = false;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [getStockVegetablesById.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [sortStockVegetables.pending]: (state, ) => {
      state.isLoading = true;
    },
    [sortStockVegetables.fulfilled]: (state, action) => {
      state.data = action.payload.data;
      state.isError = false;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [sortStockVegetables.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [postStockVegetables.pending]: (state, ) => {
      state.isLoading = true;
    },
    [postStockVegetables.fulfilled]: (state, action) => {
      state.postMessage = action.payload.message;
      state.postStatus = action.payload.status;
    },
    [postStockVegetables.rejected]: (state, action) => {
      state.isError = true;
      state.postMessage = action.payload.message;
    },
    [deleteStockVegetables.pending]: (state, ) => {
      state.isLoading = true;
    },
    [deleteStockVegetables.fulfilled]: (state, action) => {
      state.deleteMessage = action.payload.message;
      state.deleteStatus = action.payload.status;
    },
    [deleteStockVegetables.rejected]: (state, action) => {
      state.isError = true;
      state.deleteMessage = action.payload.message;
    },
    [updateStockVegetables.pending]: (state, ) => {
      state.isLoading = true;
    },
    [updateStockVegetables.fulfilled]: (state, action) => {
      state.updateMessage = action.payload.message;
      state.status = action.payload.status;
    },
    [updateStockVegetables.rejected]: (state, action) => {
      state.isError = true;
      state.updateMessage = action.payload.message;
    },
  },
});

export const stockVegetablesActions = stockVegetablesSlice.actions;

export default stockVegetablesSlice.reducer;
